import { createContext } from 'react';

import type { AuthSessionData } from './AuthSession';

export type AuthContextProps = {
	isLoading: boolean;
	error?: Error;
	/** Resolves with `twoFactorToken` when the account needs a code; `completeTwoFactorSignIn` takes it. */
	signIn: (email: string, password: string, invitationCode?: string) => Promise<{ twoFactorToken?: string }>;
	completeTwoFactorSignIn: (twoFactorToken: string, code: string, email: string) => Promise<void>;
	refreshToken: (force?: boolean) => Promise<void>;
	signOut: () => void;
	googleSignIn: (idToken: string, invitationCode?: string) => Promise<{ isNewUser: boolean }>;
	isAuthenticated: () => boolean;
	getSession: () => AuthSessionData | null;
};

export const AuthContext = createContext<AuthContextProps | null>(null);
